import * as React from "react";
import {Link} from "react-router-dom";
import styled from "styled-components";
import {
    ConstBreakPoint,
    ConstColor,
    ConstFontStyle,
    ConstShadow,
    ConstWidth,
} from "../../../../config/styles_const/styles_const";
import {IOccupationSkillTagRepository} from "../../../../domain/repository/skill_tag_repository";
import {createApiClient, IApiClient} from "../../../../infra/api/client";
import {entity} from "../../../../infra/api/rpc/api";
import {createOccupationSkillTagAPI} from "../../../../infra/api/service/skill_tag_api";
import Assets from "../../../assets/img/assets";
import HeadlineSmall from "../../../common/atom/text/headline_small";
import ClientScoutCustomersSearchForm from "../../../common/organism/client_scout_customes_search_form";

const searchWordArray = [
    "資金調達",
    "新規事業開発",
    "海外進出",
    "営業強化",
    "中期経営計画策定",
    "Webマーケティング",
    "セキュリティ強化",
    "カスタマーサクセス",
    "DX推進",
    "IPO支援",
];

interface IProps {
    handleSearch: (values: any) => void;
}

const apiClient: IApiClient = createApiClient();
const occupationSkillTagRepository: IOccupationSkillTagRepository =
    createOccupationSkillTagAPI(apiClient);

const ClientTopPageHeader: React.FC<IProps> = (props) => {
    const {handleSearch} = props;

    const [categories, setCategories] = React.useState<
        entity.IOccupationSkillTagCategory[]
    >([]);

    React.useEffect(() => {
        try {
            occupationSkillTagRepository.getAllCategory().then((items) => {
                setCategories(items);
            });
        } catch (e) {

        }
    }, []);

    return (
        <Wrapper>
            <Img>
                <NetworkBand>
                    <NetworkText>LIBERA EXPERT NETWORK</NetworkText>
                </NetworkBand>
                <ContentWrapper>
                    <ContentInner>
                        <TitleWrapper>
                            {/* <Title>
                膨大な量の職務経歴データから、
                <br />
                キーワードでエキスパートを検索できます。
              </Title> */}

                            <NewLink to={`/client/agentic-search`}>
                                <EnMark>EN</EnMark>
                                <div>✨AIエージェントでの検索を試してみる</div>
                                {/*<NewLinkIcon src={Assets.new_search}/>*/}

                                {/*<LinkIconContainer>*/}
                                {/*    <LinkIcon src={Assets.help} onClick={() => {*/}
                                {/*    }}/>*/}
                                {/*    <Tooltip>*/}
                                {/*        エキスパートのフリーワード検索機能です。*/}
                                {/*        <br/>*/}
                                {/*        経歴や資格、専門領域など、なるべく単語ベースで検索、*/}
                                {/*        <br/>*/}
                                {/*        また複数ある場合はスペース区切りで複数の単語を並べて検索をすると*/}
                                {/*        <br/>*/}
                                {/*        条件に合致するエキスパートが見つけやすくなります。*/}
                                {/*    </Tooltip>*/}
                                {/*</LinkIconContainer>*/}
                            </NewLink>
                        </TitleWrapper>

                        <SearchWrapper className={"SearchWrapper"}>
                            <ClientScoutCustomersSearchForm
                                form={"scoutCustomerSearchForm"}
                                onSubmit={handleSearch}
                                initialValues={{
                                    categories,
                                }}
                            />
                        </SearchWrapper>
                        <FocusWithinStyle className={"FocusWithinStyle"}/>
                        <SearchWordWrapper>
                            {searchWordArray.map((searchWord) => {
                                return (
                                    <SearchWordLink
                                        key={searchWord}
                                        to={`/client/scout/customers?q=${searchWord}&p=1`}
                                    >
                                        <SearchWord>#{searchWord}</SearchWord>
                                    </SearchWordLink>
                                );
                            })}
                        </SearchWordWrapper>
                    </ContentInner>
                </ContentWrapper>
            </Img>
        </Wrapper>
    );
};

export default ClientTopPageHeader;

const FocusWithinStyle = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    transition: all 0.3s ease;
`;

const Wrapper = styled.div`
    position: relative;

    & .SearchWrapper:focus-within + .FocusWithinStyle {
        background: rgba(0, 41, 80, 0.59);
    }
`;

const Img = styled.div`
    position: relative;
    width: 100%;
    height: 300px;
    background: #3f5c65;
    background-image: url(${Assets.client_top_page_header}); /* fallback */
    background-image: url(${Assets.client_top_page_header}),
    linear-gradient(100.05deg, #48e0a9 0%, #0992bd 100%); /* W3C */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        height: 300px;
    }
`;

const NetworkBand = styled.div`
    position: absolute;
    right: 14px;
    bottom: 16px;
    width: 0;
    height: 0;
    pointer-events: none;
    z-index: 2;
`;

const NetworkText = styled.span`
    position: absolute;
    left: 0;
    bottom: 0;
    transform-origin: left bottom;
    transform: rotate(-90deg);
    white-space: nowrap;
    color: ${ConstColor.White};
    font-style: normal;
    font-weight: normal;
    font-size: 9px;
    letter-spacing: 2px;
    opacity: 0.85;
`;

const ContentWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    padding: 20px 20px 0;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        padding: 20px 50px 0;
    }
`;

const ContentInner = styled.div`
    box-sizing: content-box;
    max-width: ${ConstWidth.ContentsMaxWidth};
    margin: 0 auto;
`;

const TitleWrapper = styled.div`
    margin-bottom: 20px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin-bottom: 30px;
    }
`;

const Title = styled(HeadlineSmall)`
    color: ${ConstColor.White} @media screen and(
    min-width: ${ConstBreakPoint.Default}) {
    font-weight: ${ConstFontStyle.HeadlineMiddle.fontWeight};
    font-size: ${ConstFontStyle.HeadlineMiddle.fontSize};
    line-height: ${ConstFontStyle.HeadlineMiddle.lineHeight};
} color: #ffffff;
`;

const SearchWrapper = styled.div`
    margin-bottom: 15px;
    position: relative;
    z-index: 1;

    &:hover {
        box-shadow: 0px 0px 20px #005d72;
    }
`;

const SearchWordWrapper = styled.div`
    position: relative;
    z-index: 1;
    margin-bottom: 30px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin-bottom: 45px;
    }
`;

const SearchWordLink = styled(Link)`
    display: inline-block;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: ${ConstShadow.DropShadow};
    border-radius: 50px;

    margin-right: 5px;
    margin-bottom: 5px;
    padding: 5px 20px;
    transition: all 0.3s ease;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin-right: 10px;
        margin-bottom: 10px;
    }

    &:hover {
        background: ${ConstColor.White};
        box-shadow: ${ConstShadow.DropShadow};
    }
`;

const SearchWord = styled.span`
    font-style: normal;
    font-weight: bold;
    font-size: 8px;
    line-height: 18px;
    text-align: center;

    color: ${ConstColor.Base};

    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        font-size: 10px;
    }
`;

const EnMark = styled.span`
    position: absolute;
    left: -58px;
    top: 50%;
    transform: translateY(-50%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 30px;
    border: 1.5px solid ${ConstColor.White};
    border-radius: 999px;
    color: ${ConstColor.White};
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 1px;
`;

const NewLink = styled(Link)`
    display: flex;
    margin-top: 20px;
    color: ${ConstColor.White} @media screen and(
    min-width: ${ConstBreakPoint.Default}) {
    font-weight: ${ConstFontStyle.HeadlineMiddle.fontWeight};
    font-size: ${ConstFontStyle.HeadlineMiddle.fontSize};
    line-height: ${ConstFontStyle.HeadlineMiddle.lineHeight};
} color: #ffffff;
    position: relative;
    z-index: 5;
    width: 500px;
`;

const NewLinkIcon = styled.img`
    width: 20px;
    height: 20px;
`;

const LinkIcon = styled.img`
    display: block;
    margin-left: 10px;
    cursor: pointer;
`;

const Tooltip = styled.div`
    position: absolute;
    top: 20px;
    right: 0px;
    background-color: #333;
    color: white;
    padding: 16px;
    border-radius: 5px;
    font-size: 10px;
    line-height: 14px;
    z-index: 3;
`;

const LinkIconContainer = styled.div`
    & > ${Tooltip} {
        display: none;
    }

    // ホバー時にツールチップを表示する

    &:hover > ${Tooltip} {
        display: block;
    }
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/top_page/client_top_page_header.tsx